import script from "./MemberRules.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberRules.vue?vue&type=script&setup=true&lang=js"

import "./MemberRules.vue?vue&type=style&index=0&id=57f47cb2&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57f47cb2"]])

export default __exports__